import { render, staticRenderFns } from "./SimpleConfirmDialog.vue?vue&type=template&id=ad9de336&scoped=true"
import script from "./SimpleConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./SimpleConfirmDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9de336",
  null
  
)

export default component.exports